import apiClient from './apiClient';

export interface DocumentType {
  id?: number;
  document_code: string;
  document_name: string;
  category_id: number;
  is_mandatory: boolean;
  requires_validation: boolean;
  requires_number: boolean;
  requires_expiry: boolean;
  allowed_formats?: string[];
  max_file_size_mb?: number;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface DocumentTypeFilters {
  category_id?: number;
  is_active?: boolean;
  is_mandatory?: boolean;
  search?: string;
}

const documentTypeApi = {
  getAll: (filters?: DocumentTypeFilters) => {
    let endpoint = '/archive/document-types';
    if (filters) {
      const params = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, String(value));
        }
      });
      const queryString = params.toString();
      if (queryString) endpoint += `?${queryString}`;
    }
    return apiClient.get<DocumentType[]>(endpoint);
  },

  getById: (id: number) => {
    return apiClient.get<DocumentType>(`/archive/document-types/${id}`);
  },

  create: (data: Partial<DocumentType>) => {
    return apiClient.post<DocumentType>('/archive/document-types', data);
  },

  update: (id: number, data: Partial<DocumentType>) => {
    return apiClient.put<DocumentType>(`/archive/document-types/${id}`, data);
  },

  delete: (id: number) => {
    return apiClient.delete(`/archive/document-types/${id}`);
  },
};

export default documentTypeApi;
